import { Popover, PopoverProps } from '@lmig/lmds-react-popover';
import { useEffect, useState } from 'react';

type SmartPopoverProps = PopoverProps & {
  triggerId: string;
  popoverId: string;
  closed?: boolean;
  onPopoverClose?: () => void;
};
export default function SmartPopover({
  triggerId,
  popoverId,
  onKeyDown,
  trigger,
  align,
  direction,
  children,
  closed,
  onPopoverClose,
}: SmartPopoverProps) {
  const [isOpen, setIsOpen] = useState<boolean>();
  const [outOfSync, setOutOfSync] = useState<boolean>(false);

  useEffect(() => {
    if (closed != undefined) {
      setIsOpen(false);
      setOutOfSync(true);
    }
  }, [closed]);

  const onOpen = () => setIsOpen(true);
  const onClose = () => {
    /*
    lmds popover doesnt fully support a controlled state, and doesnt register a click over the iframe
    so we need to retrigger it when it gets out of sync. this also includes being able to close the popover from a click within it.
    */
    if (outOfSync && (isOpen || (document.activeElement && document.activeElement.id == triggerId))) {
      setTimeout(() => (document.getElementById(popoverId)?.firstChild as HTMLButtonElement)?.click());
      setOutOfSync(false);
    } else setIsOpen(false);
    if (onPopoverClose) onPopoverClose();
  };

  return (
    <>
      {isOpen && <div className="smart-popover-click-capture-overlay" onClick={() => setIsOpen(false)}></div>}
      <Popover
        id={popoverId}
        onKeyDown={onKeyDown}
        trigger={trigger}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
        variant="custom"
        direction={direction ?? 'below'}
        align={align ?? 'start'}
        className={isOpen ? 'open' : 'closed'}
      >
        {children}
      </Popover>
    </>
  );
}
